export default "__VITE_ASSET__6806bd51__"